/*eslint-disable no-unused-vars*/
import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import '../../styles/dashboard/submissionStatusData.css';
import * as filterMsgs from '../../constants/establishmentFilterConstants';
import * as pathConsts from '../../constants/pathConstants';
import * as establishmentActions from '../../actions/establishmentActions.js';
import ReactTooltip from 'react-tooltip';
import {Glyphicon} from 'react-bootstrap';

export class SubmissionStatusData extends React.Component {
  onClick(filter, establishments) {
    this
      .props
      .actions
      .setFrontPageFilter(filter, establishments);
  }
  render() {
    let establishmentsActive = this.props.establishments
      .filter(establishment => establishment.establishment_status == 1);
    let numNotStarted = establishmentsActive
      .filter(establishment => establishment.submission_status == 1)
      .length;
    let establishmentsNotStarted = establishmentsActive
      .filter(establishment => establishment.submission_status == 1);
    let numInProgress = establishmentsActive
      .filter(establishment => establishment.submission_status == 2)
      .length;
    let establishmentsInProgress = establishmentsActive
      .filter(establishment => establishment.submission_status == 2);
    let numSubmitted = establishmentsActive
      .filter(establishment => establishment.submission_status == 3)
      .length;
    let establishmentsSubmitted = establishmentsActive
      .filter(establishment => establishment.submission_status == 3);
    let numTotal = numNotStarted + numInProgress + numSubmitted;
    let currentYear = new Date().getFullYear()-1;
    return (
      <div className="submission-data">
        <h3>
          {currentYear} Data Submission Status
        </h3>
        <table className="table">
          <tbody>
            <tr>
              <th>
                Status
              </th>
              <th>
                Establishments
              </th>
            </tr>
            <tr>
              <td>
                Not Added
                <span className="tooltip-container">
                  <Glyphicon
                    glyph="info-sign"
                    className="span-tooltip"
                    data-tip
                    data-for="not-started"/>
                  <ReactTooltip id="not-started" place="right" type="dark" effect="float">
                    Not Added: Data has not been added for these establishments.
                  </ReactTooltip>
                </span>
              </td>
              <td>
                <Link
                  to={pathConsts.pathToEstablishmentsDashboardPage}
                  onClick={() => this.onClick(filterMsgs.not_started, establishmentsNotStarted)}>
                  {numNotStarted}
                </Link>
              </td>
            </tr>
            <tr>
              <td>
                Not Submitted
                <span className="tooltip-container">
                  <Glyphicon
                    glyph="info-sign"
                    className="span-tooltip"
                    data-tip
                    data-for="not-submitted"/>
                  <ReactTooltip id="not-submitted" place="right" type="dark" effect="float">
                    Not Submitted: Data has been added for these establishments, but
                    has not been submitted to OSHA.
                  </ReactTooltip>
                </span>
              </td>
              <td>
                <Link
                  to={pathConsts.pathToEstablishmentsDashboardPage}
                  onClick={() => this.onClick(filterMsgs.in_progress, establishmentsInProgress)}>
                  {numInProgress}
                </Link>
              </td>
            </tr>
            <tr>
              <td>
                Submitted
                <span className="tooltip-container">
                  <Glyphicon
                    glyph="info-sign"
                    className="span-tooltip"
                    data-tip
                    data-for="submitted"/>
                  <ReactTooltip id="submitted" place="right" type="dark" effect="float">
                    Submitted: Data has been added and submitted for these
                    establishments.
                  </ReactTooltip>
                </span>
              </td>
              <td>
                <Link
                  to={pathConsts.pathToEstablishmentsDashboardPage}
                  onClick={() => this.onClick(filterMsgs.submitted, establishmentsSubmitted)}>
                  {numSubmitted}
                </Link>
              </td>
            </tr>
            <tr className="total-row">
              <td>
                Total
              </td>
              <td>
                <Link to={pathConsts.pathToEstablishmentsDashboardPage}>
                  {numTotal}
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

}
SubmissionStatusData.propTypes = {
  establishments: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired
};

function mapStateToProps(ownProps) {
  return {establishments: ownProps.establishments};

}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(establishmentActions, dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SubmissionStatusData);



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/SubmissionStatusData.js
 **/